import { configureStore } from "@reduxjs/toolkit";
import FunctionSlice from "./Slices/FunctionSlice";

export const store = configureStore({
  reducer: {
    functionslice: FunctionSlice,
  }
})